enum FolderOptionValue {
  TogglePin = 'togglePin',
  Edit = 'edit',
  Remove = 'remove',
}

export default FolderOptionValue;
